import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideConfig,
} from '@spartacus/core';
import { AddCardModule } from '../shared/modules/add-card/add-card.module';
import { ProfileAdBannerModule } from '../shared/modules/profile-ad-Banner/profile-ad-Banner.module';
import { AccountComponent } from './account/account.component';
import { CustomProfileAndPreferencesComponent } from './custom-profile-and-preferences/custom-profile-and-preferences.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { PaymentComponent } from './payment/payment.component';
import { UserComponent } from './user/user.component';
import { CustomUserRegistrationModule } from "../custom-user-registration/custom-user-registration.module";
import { PhoneSectionComponent } from "./phone-section/phone-section.component";
import { CreditsListComponent } from "../custom-make-a-payment/credits-list/credits-list.component";
import {
	GoToMakePaymentPageButtonComponent
} from "../account-overview/account-overview/go-to-make-payment-page-button/go-to-make-payment-page-button.component";
import { InvoicesListComponent } from "../custom-make-a-payment/invoices-list/invoices-list.component";
import { OrdersTableComponent } from "../order-history/orders-table/orders-table.component";
import { SpinnerModule } from '@spartacus/storefront';

@NgModule({
  declarations: [
    CustomProfileAndPreferencesComponent,
    MyAccountComponent,
    UserComponent,
    AccountComponent,
    PaymentComponent,
  ],

	imports: [
		CommonModule,
		NgbModule,
		NgSelectModule,
		ReactiveFormsModule,
		BrowserModule,
		I18nModule,
		FormsModule,
		AddCardModule,
		ProfileAdBannerModule,
		FontAwesomeModule,
		ConfigModule.withConfig({
			cmsComponents: {
				AccountProfilePreferenceComponent: {
					component: () =>
						import(
							'./custom-profile-and-preferences/custom-profile-and-preferences.component'
							).then((m) => m.CustomProfileAndPreferencesComponent),
					guards: [AuthGuard]
				}
			}
		} as CmsConfig),
		CustomUserRegistrationModule,
		PhoneSectionComponent,
		CreditsListComponent,
		GoToMakePaymentPageButtonComponent,
		InvoicesListComponent,
		OrdersTableComponent,
		SpinnerModule
	],

  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class CustomProfileAndPreferencesModule {}
